export const SET_LAYOUT_DIRECTION: string = "SET_LAYOUT_DIRECTION";

export const SET_LAYOUT_RTL: string = "SET_LAYOUT_RTL";
export const SET_LAYOUT_LTR: string = "SET_LAYOUT_LTR";
